import { NeutralColors, SharedColors } from '@fluentui/react';
import React from 'react';
import Highlighter from 'react-highlight-words';
var Highlight = function (props) { return (React.createElement("span", { style: { backgroundColor: props.highlightBackgroundColor, color: props.highlightTextColor, fontWeight: 600 }, "aria-label": props.ariaLabel }, props.children.children)); };
export var HighlightFilterText = function (props) {
    var searchText = props.searchText, fullText = props.fullText, searchAriaLabel = props.searchAriaLabel, highlightColor = props.highlightColor, textColor = props.textColor;
    return (React.createElement(Highlighter, { searchWords: searchText, autoEscape: true, textToHighlight: fullText, highlightTag: function (children) {
            return Highlight({
                children: children,
                ariaLabel: (searchAriaLabel !== null && searchAriaLabel !== void 0 ? searchAriaLabel : 'filter match for') + " " + children.children,
                highlightBackgroundColor: highlightColor !== null && highlightColor !== void 0 ? highlightColor : SharedColors.yellow10,
                highlightTextColor: textColor !== null && textColor !== void 0 ? textColor : NeutralColors.gray160
            });
        } }));
};
//# sourceMappingURL=HighlightFilterText.js.map